import {
  PublishingStatuses,
  WorkflowStatuses,
  TaskStatuses,
} from '@opallabs/concepts'

type StatusConfig = {
  string: string
  icon: WorkflowStatuses | PublishingStatuses | TaskStatuses
}

export type Statuses =
  | 'notCreated'
  | 'notStarted'
  | 'tasksPending'
  | 'tasksComplete'
  | 'approvalPending'
  | 'approved'
  | 'declined'
  | 'circuitBreaker'

export const statuses: Omit<Record<Statuses, StatusConfig>, 'notCreated'> = {
  notStarted: {
    string: 'Workflow Not Started',
    icon: 'not-started',
  },
  tasksPending: {
    string: 'Tasks Pending',
    icon: 'tasks-pending',
  },
  tasksComplete: {
    string: 'All Tasks Complete ',
    icon: 'tasks-complete',
  },
  approvalPending: {
    string: 'Approval Pending ',
    icon: 'approval-pending',
  },
  approved: {
    string: 'Moment Approved ',
    icon: 'approval-approved',
  },
  declined: {
    string: 'Moment Declined ',
    icon: 'approval-denied',
  },
  circuitBreaker: {
    string: 'Workflow Paused ',
    icon: 'paused',
  },
}
